import Flux from 'lib/flux';

const TourAvailabilityConstants = Flux.createConstants({
  serviceMessages: [
    'LOAD_DATES',
    'LOAD_API_DATES_FINISHED',
    'FILTER_DATES',
    'GET_AVAILABLE_DATES',
    'GET_AVAILABLE_DATES_FINISHED',
  ],
});

export default TourAvailabilityConstants;
